/**
 * legacyStorage — removes browser storage left behind by retired features.
 *
 * The in-app `/admin` client (removed in #248) kept an audit ring buffer in
 * `localStorage['humblytics:admin-audit:v1']` (staff identity, customer
 * emails, search queries, impersonation targets) and a session id in
 * `sessionStorage['humblytics:admin-session:v1']`. Nothing writes those keys
 * any more, but browsers that used the old page still hold them, and logout
 * no longer cleared them. This drops them on every app boot and on logout.
 */

const LEGACY_LOCAL_KEYS = ['humblytics:admin-audit:v1'] as const
const LEGACY_SESSION_KEYS = ['humblytics:admin-session:v1'] as const

export function purgeLegacyStorage(): void {
  try {
    for (const key of LEGACY_LOCAL_KEYS) localStorage.removeItem(key)
  } catch {
    // localStorage unavailable (private mode, blocked site data).
  }
  try {
    for (const key of LEGACY_SESSION_KEYS) sessionStorage.removeItem(key)
  } catch {
    // sessionStorage unavailable.
  }
}
